import React from 'react';
import { ObjectiveAnswer } from '../../../../types';
import {
  AnswersStyled,
  AnswerStyled,
  AnswerContent,
  AnswerImage,
  ResultOptionIcon,
} from './styles';
import { getOptionLabel, getAnswerStatus, buildImgSrc } from '../../utils/utils';
import { MESSAGES, IDK_ANSWER_ID } from '../../utils/constants';
import checkIcon from 'img/check.svg';
import timesWhiteIcon from 'img/times-white.svg';

interface AnswerListProps {
  answers: ObjectiveAnswer[];
  questionAnswer?: number;
  questionAnswerCorrect?: number;
  onSelectAnswer: (answerId: number) => void;
  resolved?: boolean;
}

export const AnswerList: React.FC<AnswerListProps> = ({
  answers,
  questionAnswer,
  questionAnswerCorrect,
  onSelectAnswer,
  resolved,
}) => {
  const filteredAnswers =
    answers
      ?.filter((answer) => answer.resposta || answer.img_resposta)
      .sort((a, b) => (a.order ?? 0) - (b.order ?? 0)) || [];
  const idkLetterIndex = filteredAnswers.length;
  const idkStatus = getAnswerStatus(IDK_ANSWER_ID, questionAnswer, questionAnswerCorrect);

  const isIncorrectIdk =
    resolved && !filteredAnswers.some((answer) => answer.answereds?.[0]?.is_marked);
  return (
    <AnswersStyled>
      {filteredAnswers.map((answer, index) => {
        const status = getAnswerStatus(answer.id_resposta, questionAnswer, questionAnswerCorrect);
        const imgSrc = buildImgSrc(answer.img_resposta);

        return (
          <AnswerStyled
            key={answer.id_resposta}
            checked={status.isUserAnswer}
            incorrect={status.showAsWrong}
            correct={status.showAsCorrect || status.showCorrectAnswer}
            onClick={() => onSelectAnswer(answer.id_resposta)}
            className={resolved ? 'answered' : ''}
          >
            <ResultOptionIcon
              className={
                status.showAsCorrect
                  ? 'is-correct'
                  : status.showAsWrong
                  ? 'is-incorrect'
                  : status.showCorrectAnswer
                  ? 'is-correct-answer'
                  : status.isUserAnswer && !status.isChecked
                  ? 'is-selected'
                  : ''
              }
            >
              {(status.showAsCorrect || status.showCorrectAnswer) && <img src={checkIcon} alt="" />}
              {status.showAsWrong && <img src={timesWhiteIcon} alt="" />}
              {getOptionLabel(index)}
            </ResultOptionIcon>{' '}
            <AnswerContent>
              {answer.resposta && <span>{answer.resposta}</span>}
              {imgSrc && (
                <AnswerImage
                  src={imgSrc}
                  // Alternativa só-imagem não tem texto nenhum: sem alt, o leitor de
                  // tela anuncia uma opção vazia. Com texto, a imagem é complementar.
                  alt={answer.resposta ? '' : `Alternativa ${getOptionLabel(index).toUpperCase()}`}
                />
              )}
            </AnswerContent>
          </AnswerStyled>
        );
      })}
      <AnswerStyled
        checked={idkStatus.isUserAnswer || (isIncorrectIdk && resolved)}
        incorrect={isIncorrectIdk}
        correct={false}
        onClick={() => onSelectAnswer(IDK_ANSWER_ID)}
        className={resolved ? 'answered' : ''}
      >
        <ResultOptionIcon
          className={
            isIncorrectIdk
              ? 'is-incorrect'
              : (isIncorrectIdk && resolved) || idkStatus.isUserAnswer
              ? 'is-selected'
              : ''
          }
        >
          {isIncorrectIdk && <img src={timesWhiteIcon} alt="" />}
          {getOptionLabel(idkLetterIndex)}
        </ResultOptionIcon>{' '}
        {MESSAGES.I_DONT_KNOW}
      </AnswerStyled>
    </AnswersStyled>
  );
};
